;
/*!
 * subitotexto.menu.js
 */

SubitoTexto.menu = {
	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.menu;


		_this.$body = $( 'body' );
		_this.$menuToggler = $( '.main-menu-toggler' );
		_this.menuOpen = false;

		if ( _this.$menuToggler.length < 1 ) {
			return;
		}

		_this.$mainNav = $( '#main-nav' );
		_this.$menuElements = _this.$mainNav.find( 'li' ).find( 'a' );

		_this.$elementAfterMenu = $( '.site-title' ).find( 'a' );

		if ( _this.$elementAfterMenu.length < 1 ) {
			_this.$elementAfterMenu = $( '.btn-retour' ).eq( 0 );
		}

		_this.$linkJumpToContent = $( '.jump-to-content' );

		_this.$headerTitle = $( '.site-title' );

		_this.$mainNav.attr('aria-hidden', true);

		_this.bindEvents();


	}, // init()
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.menu;

		_this.$mainNav.add(_this.$menuToggler).on( 'keydown', function ( e ) {
			console.log('KeyDown', e);
			_this.handleKeys( e );
		} );


		// Don't focus if menu is hidden
		// _this.$mainNav.on( 'keyup', 'a', function ( e ) {
		// 	if ( !_this.$menuToggler.hasClass( 'open' ) ) {
		// 		if ( e.keyCode == PLA.a11y.keys.tab ) {
		// 			e.preventDefault();
		//
		// 			if ( e.shiftKey == true ) {
		// 				_this.$menuToggler.focus();
		// 			} else {
		// 				_this.$elementAfterMenu.focus();
		// 			}
		// 		}
		// 	}
		// } );


		_this.$menuToggler.on( 'click', function ( e ) {
			e.preventDefault();

			if ( _this.$menuToggler.hasClass( 'open' ) ) {
				_this.closeMenu();
			} else {
				_this.openMenu();
			}
		} );


		// _this.$headerTitle.on( 'keyup', function ( e ) {
		// 	if ( !_this.$menuToggler.hasClass( 'open' ) ) {
		// 		if ( e.keyCode == PLA.a11y.keys.tab ) {
		// 			e.preventDefault();
		//
		// 			if ( e.shiftKey == true ) {
		// 				_this.$menuToggler.focus();
		// 			} else {
		// 				_this.$elementAfterMenu.focus();
		// 			}
		// 		}
		// 	}
		// } )


	}, // bindEvents()
	openMenu  : function () {
		var $ = jqPla,
			_this = SubitoTexto.menu;

		_this.$body.addClass( 'menu-open' ).removeClass( 'menu-closed' );
		_this.menuOpen = true;

		_this.$menuToggler.add( _this.$mainNav ).attr( {
			'aria-expanded': 'true'
		} );

		_this.$mainNav.attr('aria-hidden', false);

		_this.$mainNav.add( _this.$menuToggler ).addClass( 'open' );

		_this.$mainNav.find( 'a' ).attr( 'tabindex', 0 );

		_this.$menuElements.eq( 0 ).focus();

	},
	closeMenu : function () {
		var $ = jqPla,
			_this = SubitoTexto.menu;

		_this.$body.addClass( 'menu-closed' ).removeClass( 'menu-open' );
		_this.menuOpen = false;

		_this.$menuToggler.add( _this.$mainNav ).attr( {
			'aria-expanded': 'false'
		} );

		_this.$mainNav.attr('aria-hidden', true);

		_this.$mainNav.find( 'a' ).attr( 'tabindex', -1 );

		_this.$mainNav.add( _this.$menuToggler ).removeClass( 'open' );

	},

	handleKeys: function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.menu;

		//console.log( e.keyCode, e.shiftKey );


		if ( e.altKey || e.ctrlKey ) {
			// Modifier key pressed: Do not process
			return true;
		}

		// ESC pressed : close the menu
		if ( e.keyCode === PLA.a11y.keys.esc ) {
			_this.closeMenu();
			_this.$menuToggler.focus();
		}

			console.log('Menu is closed', e.keyCode);
		// If the menu is closed skip the menu items
		if ( !_this.menuOpen ) {
			if ( e.keyCode === PLA.a11y.keys.down || e.keyCode === PLA.a11y.keys.right || ( e.shiftKey === false && e.keyCode === PLA.a11y.keys.tab ) ) {

				e.preventDefault();
				_this.$elementAfterMenu.focus();
				return;

			} else if ( e.keyCode === PLA.a11y.keys.up || e.keyCode === PLA.a11y.keys.left || (e.shiftKey === true && e.keyCode === PLA.a11y.keys.tab) ) {

				e.preventDefault();
				_this.$linkJumpToContent.focus();
				return;

			}
		}

		else if ( e.keyCode === PLA.a11y.keys.down || e.keyCode === PLA.a11y.keys.right || ( e.shiftKey === false && e.keyCode === PLA.a11y.keys.tab ) ) {
			e.preventDefault();

			var $currEl = _this.$mainNav.find( 'a:focus' );

			// On a link
			if ( $currEl.length > 0 ) {
				var $currElParent = $currEl.parent( 'li' );

				if ( $currElParent ) {
					var $nextLi = $currElParent.next( 'li' ),
						$nextLink = $nextLi.find( 'a' );

					if ( $nextLink.length > 0 ) {
						$nextLink.focus();
					} else {

						// if ( _this.$elementAfterMenu.length > 0 ) {
						// 	_this.closeMenu();
						// 	//_this.$elementAfterMenu.focus();
						// 	_this.$menuToggler.focus();
						// }

						_this.$menuToggler.focus();
					}
				}

			}

			// On the menu toggler
			else {
				_this.$menuElements.eq( 0 ).focus();
			}

		} else if ( e.keyCode === PLA.a11y.keys.up || e.keyCode === PLA.a11y.keys.left || (e.shiftKey === true && e.keyCode === PLA.a11y.keys.tab) ) {
			e.preventDefault();

			var $currEl = _this.$mainNav.find( 'a:focus' );

			// On a link
			if ( $currEl.length > 0 ) {
				var $currElParent = $currEl.parent( 'li' );

				if ( $currElParent ) {
					var $prevLi = $currElParent.prev( 'li' ),
						$prevLink = $prevLi.find( 'a' );

					if ( $prevLink.length > 0 ) {
						$prevLink.focus();
					} else {
						_this.$menuToggler.focus();
					}
				}
			}

			// On the menu toggler
			else {
				_this.$menuElements.last().focus();
			}
		}

		// 2017-03-28 Tab should now act like arrows
		//
		// else if ( e.keyCode == PLA.a11y.keys.tab && e.shiftKey == false ) {
		// 	e.preventDefault();
		//
		// 	_this.closeMenu();
		//
		// 	_this.$elementAfterMenu.focus();
		// } else if ( e.keyCode == PLA.a11y.keys.tab && e.shiftKey == true ) {
		// 	e.preventDefault();
		//
		// 	_this.$menuToggler.focus();
		// }


	}
}; // SubitoTexto.menu